
export const STATUS_OPTIONS = ["Completed", "In Progress", "Not Started"];

export const FILTER_TYPE_OPTIONS = [
    { value: "INDIVIDUAL", label: "Individuals" },
    { value: "BUNDLE", label: "Curriculums" },
];

export const SUB_TYPE_OPTIONS = [
    { value: "USER", label: "Users" },
    { value: "GROUP", label: "Groups" },
];


export const STATUS_FILTER_OPTIONS = [
    ...STATUS_OPTIONS.map((s) => ({ value: s, label: s })),
];

export const ADHERENCE_ORDER = [
    "Overdue", "Not Due Yet", "Behind Schedule", "On Track", "Late", "On Time",
];


